export default __webpack_public_path__ + "static/media/mwars-coin.6dd70ee4.png";